import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Colors } from "design-system";

const Logo = React.memo(({ width = "167", height = "40", theme = "dark" }) => {
  const st0 = useMemo(
    () => ({ fill: theme === "light" ? Colors.Grey900 : Colors.White }),
    [theme]
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 271 64.9"
      width={width}
      height={height}
    >
      <g>
        <g>
          <path
            style={st0}
            d="M64.94,31.85c0-.45-.02-.9-.05-1.35l-16.46.7,16.35-2.13c-.04-.43-.1-.85-.16-1.28l-17.13,2.24,16.89-3.72c-.08-.4-.16-.8-.25-1.19l-17.65,3.89,17.25-5.42c-.1-.37-.21-.74-.33-1.1l-18.02,5.66,17.47-7.21c-.13-.34-.26-.68-.4-1.01l-17.92,7.4c.14.32.25.64.36.98,0,.01.01.03.01.04.1.31.19.63.27.95,0,.04.02.07.03.11.07.3.13.6.18.9.01.06.02.12.03.18.04.28.08.56.11.84,0,.08,0,.17.01.25.02.26.04.52.04.78,0,.03,0,.07,0,.1,0,.07-.01.15-.01.22,0,.24-.02.47-.04.71,0,.13,0,.26-.02.39-.02.22-.06.42-.09.64-.02.15-.04.3-.07.45-.04.19-.08.38-.12.56-.04.17-.09.34-.13.51-.04.16-.08.33-.13.49-.06.19-.13.37-.2.55-.05.14-.1.28-.15.42-.08.2-.18.4-.27.6-.05.12-.11.23-.16.34-.11.22-.22.43-.34.64-.05.09-.11.18-.16.27-.14.23-.27.45-.42.67-.05.07-.1.14-.15.2-.17.23-.33.46-.51.68-.04.05-.09.1-.13.15-.2.23-.4.46-.62.68-.03.03-.06.07-.09.1-.23.23-.48.45-.73.66-.02.02-.04.03-.06.05-.26.23-.54.44-.83.64,0,0,0,0-.01.01-.29.21-.59.4-.89.59-.01,0-.02.01-.03.02-.3.18-.6.34-.91.49-.03.01-.06.03-.09.04-.29.14-.59.28-.9.4-.05.02-.1.03-.14.05-.29.11-.58.22-.88.31-.07.02-.13.03-.2.05-.28.08-.57.16-.86.22-.09.02-.17.03-.26.05-.16.03-.33.05-.5.08-.19.03-.38.07-.58.09-.02,0-.04,0-.06,0h-.02v19.41c.29-.01.58-.03.87-.05.19-.01.38-.03.57-.04.27-.02.54-.04.8-.07l-.14-3.2.41,3.17c.83-.1,1.66-.22,2.48-.38l-.51-3.89.84,3.82c.8-.17,1.59-.37,2.37-.59l-.99-4.51,1.38,4.4c.76-.23,1.51-.49,2.24-.77l-1.6-5.08,2.03,4.91c.71-.29,1.42-.59,2.11-.93l-2.3-5.58,2.77,5.34c.67-.34,1.32-.69,1.96-1.08l-3.11-5.99,3.61,5.68c.61-.38,1.21-.79,1.8-1.21l-4-6.3,4.53,5.92c.56-.42,1.1-.86,1.63-1.32l-4.97-6.5,5.51,6.03c.51-.45,1-.92,1.47-1.4l-6.01-6.58,6.55,6.01c.45-.48.89-.96,1.31-1.47l-7.1-6.52,7.63,5.87c.39-.49.77-1,1.14-1.52l-8.22-6.33,8.74,5.58c.33-.51.66-1.03.96-1.55l-9.38-5.99,9.86,5.15c.28-.51.54-1.04.8-1.57l-10.53-5.5,10.96,4.55c.23-.52.44-1.04.64-1.57l-11.66-4.85,12.03,3.81c.17-.51.33-1.03.48-1.55l-12.76-4.04,13.06,2.91c.12-.5.23-1.01.33-1.52l-13.81-3.08,14.02,1.86c.07-.49.14-.98.19-1.48l-14.79-1.97,14.9.67c.03-.47.05-.95.06-1.42l-15.68-.7,15.68-.67h0Z"
          />
          <path
            style={st0}
            d="M44.51,27.29l17.22-8.94c-.15-.31-.31-.6-.46-.9l-17.2,8.93c.16.3.31.6.44.92Z"
          />
          <path
            style={st0}
            d="M44.03,26.28l16.38-10.41c-.16-.27-.33-.54-.5-.81l-16.36,10.4c.17.27.33.54.49.82h0Z"
          />
          <path
            style={st0}
            d="M43.45,25.32l15.41-11.79c-.17-.24-.34-.48-.52-.71l-15.4,11.79c.18.23.35.47.51.72Z"
          />
          <path
            style={st0}
            d="M42.8,24.41l14.32-13.09c-.18-.2-.35-.41-.53-.61l-14.31,13.08c.18.2.35.41.52.63h0Z"
          />
          <path
            style={st0}
            d="M42.07,23.55l13.13-14.3c-.18-.17-.36-.34-.54-.51l-13.11,14.27c.18.17.35.35.52.54h0Z"
          />
          <path
            style={st0}
            d="M41.26,22.76l11.84-15.39c-.17-.14-.35-.28-.53-.42l-11.81,15.36c.17.14.34.3.51.45h0Z"
          />
          <path
            style={st0}
            d="M40.39,22.03l10.45-16.36c-.17-.12-.34-.23-.51-.34l-10.44,16.34c.17.12.33.24.49.36Z"
          />
          <path
            style={st0}
            d="M39.45,21.38l8.98-17.21c-.16-.09-.31-.18-.47-.27l-8.98,17.2c.16.09.31.19.47.28h0Z"
          />
          <path
            style={st0}
            d="M38.45,20.8l7.45-17.92c-.14-.07-.29-.13-.43-.2l-7.44,17.91c.14.07.29.13.43.21h0Z"
          />
          <path
            style={st0}
            d="M37.4,20.32L43.26,1.82c-.13-.04-.26-.09-.38-.13l-5.85,18.49c.13.05.26.09.38.14h0Z"
          />
          <path
            style={st0}
            d="M36.31,19.92L40.53.98c-.11-.03-.22-.05-.33-.08l-4.22,18.93c.11.03.22.05.33.09Z"
          />
          <path
            style={st0}
            d="M37.73.4c-.09-.01-.18-.03-.27-.05l-2.55,19.23c.09.02.18.03.27.05L37.73.4Z"
          />
          <path
            style={st0}
            d="M34.88.07c-.07,0-.13-.01-.2-.01l-.87,19.36c.07,0,.13.02.2.03L34.88.07Z"
          />
          <path
            style={st0}
            d="M20.35,37.41L3.11,46.35c.15.31.3.61.45.91l17.21-8.92c-.15-.3-.3-.61-.43-.92h0Z"
          />
          <path
            style={st0}
            d="M20.83,38.44l-16.39,10.4c.16.27.32.54.49.81l16.37-10.39c-.16-.27-.32-.54-.47-.83h0Z"
          />
          <path
            style={st0}
            d="M21.4,39.43l-15.42,11.79c.17.24.34.48.51.72l15.41-11.78c-.17-.24-.34-.48-.5-.73Z"
          />
          <path
            style={st0}
            d="M22.05,40.37l-14.34,13.09c.17.21.35.41.53.61l14.31-13.07c-.18-.2-.35-.42-.51-.64h0Z"
          />
          <path
            style={st0}
            d="M22.78,41.25l-13.14,14.3c.18.17.36.34.54.51l13.12-14.27c-.18-.17-.34-.36-.51-.55Z"
          />
          <path
            style={st0}
            d="M23.6,42.07l-11.85,15.39c.17.15.35.28.53.42l11.82-15.35c-.17-.15-.34-.3-.5-.46h0Z"
          />
          <path
            style={st0}
            d="M24.49,42.82l-10.46,16.36c.17.12.33.23.5.34l10.45-16.34c-.17-.12-.33-.24-.49-.37h0Z"
          />
          <path
            style={st0}
            d="M25.44,43.5l-8.99,17.21c.16.09.31.18.47.27l8.99-17.19c-.16-.09-.31-.19-.47-.28h0Z"
          />
          <path
            style={st0}
            d="M26.46,44.08l-7.46,17.92c.14.07.29.13.43.2l7.45-17.91c-.14-.07-.29-.13-.43-.21Z"
          />
          <path
            style={st0}
            d="M27.53,44.58l-5.87,18.5c.13.04.26.09.38.13l5.87-18.49c-.13-.05-.26-.09-.38-.14h0Z"
          />
          <path
            style={st0}
            d="M28.65,44.98l-4.23,18.94c.11.03.22.05.33.08l4.23-18.93c-.11-.03-.22-.05-.33-.09h0Z"
          />
          <path
            style={st0}
            d="M27.25,64.51c.09.01.18.03.27.05l2.56-19.23c-.09-.02-.18-.03-.27-.04l-2.56,19.23Z"
          />
          <path
            style={st0}
            d="M30.12,64.84c.07,0,.13.01.2.01l.88-19.36c-.07,0-.13-.01-.2-.02l-.88,19.37Z"
          />
          <path
            style={st0}
            d="M30.41.05h0c-.46.03-.92.06-1.37.11l.12,2.93-.38-2.9c-.84.09-1.66.22-2.48.38l.47,3.62-.78-3.56c-.8.16-1.59.36-2.37.58l.94,4.26-1.3-4.16c-.76.22-1.51.47-2.25.75l1.52,4.86-1.94-4.7c-.72.28-1.43.58-2.11.91l2.22,5.38-2.67-5.15c-.67.33-1.32.69-1.97,1.06l3.01,5.81-3.51-5.52c-.62.38-1.22.78-1.81,1.2l3.9,6.15-4.42-5.78c-.57.42-1.11.85-1.65,1.3l4.88,6.38-5.4-5.92c-.51.45-1.01.9-1.49,1.38l5.92,6.48-6.45-5.93c-.45.47-.89.96-1.32,1.46l7.02,6.45-7.55-5.81c-.4.49-.78,1-1.15,1.51l8.15,6.28-8.67-5.55c-.34.5-.66,1.02-.98,1.55l9.32,5.96-9.8-5.12c-.29.51-.56,1.03-.82,1.56l10.49,5.48-10.92-4.55c-.23.51-.45,1.03-.65,1.56l11.64,4.85-12.02-3.81c-.18.51-.34,1.03-.49,1.55l12.76,4.05L.99,24.44c-.13.5-.24,1.01-.35,1.52l13.85,3.09L.42,27.18c-.08.49-.15.98-.2,1.47l14.85,1.98L.1,29.96c-.04.47-.06.94-.08,1.42l15.76.71-15.78.66c0,.45.01.91.03,1.35l16.58-.7L.14,35.55c.04.43.09.85.15,1.28l17.25-2.24L.53,38.33c.07.4.15.8.24,1.19l17.8-3.91L1.16,41.07c.1.37.2.74.32,1.11l18.18-5.7-17.64,7.27c.13.34.26.67.4,1.01l17.92-7.39c-.13-.32-.26-.65-.36-.99,0,0,0-.02-.01-.03-.1-.32-.18-.66-.26-.99,0-.03-.02-.07-.03-.1-.07-.31-.12-.62-.16-.93,0-.06-.02-.11-.03-.17-.04-.29-.06-.57-.08-.87,0-.08,0-.16-.01-.25,0-.2-.03-.4-.03-.6,0-.07,0-.13.01-.19,0-.11.01-.21.01-.32,0-.24.01-.48.04-.72.01-.13.03-.25.05-.38.03-.22.06-.43.1-.64.03-.15.04-.3.07-.45.04-.19.1-.38.15-.56.04-.17.08-.34.13-.51.05-.16.11-.32.16-.48.06-.19.13-.37.2-.56.05-.14.1-.28.16-.41.09-.2.19-.4.29-.6.06-.11.1-.23.16-.34.12-.22.24-.42.37-.63.05-.09.1-.17.16-.26.14-.22.29-.44.45-.66.05-.06.1-.13.14-.19.17-.23.35-.45.54-.67.04-.04.08-.09.12-.13.2-.23.41-.46.64-.68.03-.03.06-.05.08-.07.24-.23.48-.46.74-.67.01-.01.03-.02.04-.03.27-.22.55-.43.84-.63,0,0,0,0,.01,0,.28-.2.58-.38.88-.55.02-.01.04-.03.06-.04.28-.16.57-.31.87-.45.04-.02.08-.04.12-.06.28-.13.56-.25.85-.36.06-.02.12-.04.18-.07.27-.1.55-.19.83-.28.08-.02.16-.04.25-.06.26-.07.52-.15.79-.2.1-.02.2-.03.31-.05.31-.06.62-.11.93-.14.06,0,.12,0,.19-.01h0s.04,0,.07,0h0V0c-.15,0-.3,0-.45.01-.18,0-.34.02-.49.04h0Z"
          />
        </g>
        <g>
          <rect style={st0} x="85.11" y="20.3" width="3.77" height="24.17" />
          <polygon
            style={st0}
            points="117.34 38.47 102.68 20.27 98.9 20.27 98.9 44.47 102.68 44.47 102.68 26.26 117.34 44.47 121.08 44.47 121.08 20.27 117.34 20.27 117.34 38.47"
          />
          <rect style={st0} x="151.47" y="20.3" width="3.77" height="24.17" />
          <rect style={st0} x="204.68" y="20.3" width="3.77" height="24.17" />
          <path
            style={st0}
            d="M228.72,19.75c-7.12,0-12.57,5.64-12.57,12.57s5.45,12.7,12.57,12.7,12.57-5.77,12.57-12.7-5.45-12.57-12.57-12.57ZM228.72,41.44c-4.9,0-8.54-4.16-8.54-9.12s3.64-8.99,8.54-8.99,8.54,4.03,8.54,8.99-3.64,9.12-8.54,9.12Z"
          />
          <polygon
            style={st0}
            points="267.26 20.27 267.26 38.47 252.6 20.27 248.83 20.27 248.83 44.47 252.6 44.47 252.6 26.26 267.26 44.47 271 44.47 271 20.27 267.26 20.27"
          />
          <path
            style={st0}
            d="M169.02,39.64v-19.33h-3.76v20.33c0,1.91,1.5,3.83,3.86,3.83h9.51l.31-3.61h-8.73c-.66,0-1.19-.47-1.19-1.22h0Z"
          />
          <path
            style={st0}
            d="M130.82,24.13v20.33h3.76v-10.66h8.14l.35-3.62h-8.48v-5.05c0-.75.53-1.22,1.19-1.22h8.73v-3.61h-9.82c-2.36,0-3.86,1.92-3.86,3.83h0Z"
          />
          <path
            style={st0}
            d="M188.71,39.64v-19.33h-3.76v20.33c0,1.91,1.5,3.83,3.86,3.83h9.51l.31-3.61h-8.73c-.66,0-1.19-.47-1.19-1.22h0Z"
          />
        </g>
      </g>
    </svg>
  );
});

Logo.displayName = "Logo";

Logo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
};

export default Logo;
